import BaseApi from '@/core/api/baseApi'
import type { LoginCredentials, LoginResponse, User } from '@/core/types/api'
// Import type augmentation for skipAuthRefresh
import '@/core/api/axiosTypes'

export default class AuthApi extends BaseApi {
  async getProfile(): Promise<User> {
    return this.get<User>('/api-admin/users/me')
  }
  async login(credentials: LoginCredentials): Promise<LoginResponse> {
    // Skip auth refresh - login errors should be returned directly, not trigger token refresh
    return this.post<LoginResponse, LoginCredentials>('/api-admin/auth/login', credentials, {
      skipAuthRefresh: true
    })
  }

  async refreshToken(): Promise<LoginResponse> {
    // Refresh token is in HTTP-only cookie, backend will read it automatically
    // Skip auth refresh - avoid infinite loop on refresh failure
    return this.post<LoginResponse>('/api-admin/auth/refresh-token', {}, {
      skipAuthRefresh: true
    })
  }

  async logout(): Promise<void> {
    // Invalidate refresh token on server and clear cookies
    await this.post<void>('/api-admin/auth/logout', {})
  }
}

export const authApi = BaseApi.createApiInstance(AuthApi)()
